import React, { Component } from "react";
import "./IconAndTitle.scss";
import { translate } from "clavis-nxt-components-custdevtm";

class IconAndTitle extends Component {
  getTitle = () => {
    return this.props.t(
      "platform.IconAndTitle." +
        window.location.pathname.split(/(.+)/)[1].replace(/[/-]/g, "")
    );
  };

  componentDidUpdate() {
    let environment = JSON.parse(localStorage.getItem("environment"));
    document.title =
      (environment &&
      environment.environmentDescription &&
      environment.environmentType !== "PROD"
        ? environment.environmentDescription
        : "") +
      " Clavis - " +
      this.getTitle();
  }

  render() {
    return (
      <div className="icon-and-title">
        <div className="application-header-logo" />
        <div className="separation header-background-color" />
        <div className="dashboard-title huge-font-light">{this.getTitle()}</div>
      </div>
    );
  }
}

export default translate()(IconAndTitle);
